import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitButton", "checked"];

  connect() {
    // Prevent browser back button navigation during activation flow
    this.preventBackNavigation();
  }

  disconnect() {
    // Clean up event listener when controller is disconnected
    window.removeEventListener("popstate", this.handleBackButton);
  }

  toggleAcceptance(e) {
    this.submitButtonTarget.disabled = !e.currentTarget.checked;
    this.checkedTarget.setAttribute("checked", e.currentTarget.checked);
  }

  preventBackNavigation() {
    // Push current state to prevent going back
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, window.location.href);

      // Listen for back button and prevent it
      this.handleBackButton = () => {
        window.history.pushState(null, null, window.location.href);

        // Show a warning message
        const message = document.querySelector(".flash-messages");
        if (message) {
          const alertDiv = document.createElement("div");
          alertDiv.className = "alert alert-warning alert-dismissible fade show";
          alertDiv.role = "alert";
          alertDiv.innerHTML = `
            Das Zurückgehen im Formular wird nicht unterstützt. Bitte fahren Sie mit dem aktuellen Schritt fort.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          `;
          message.appendChild(alertDiv);

          // Auto-dismiss after 5 seconds
          setTimeout(() => {
            alertDiv.classList.remove("show");
            setTimeout(() => alertDiv.remove(), 150);
          }, 5000);
        }
      };

      window.addEventListener("popstate", this.handleBackButton);
    }
  }
}
